module.exports = __webpack_public_path__ + "img/j4.bd1df7f0.jpg";